import interceptor from '@/plugins/interceptor';
const pathController = '/TrafficLog'

export default {
  state: () => ({
  }),
  getters: {
  },
  mutations: { 
  },
  actions: {
    async trafficLog_generate({ dispatch }, model) {
      try {
        const request = await interceptor.authenticate.post(`${process.env.VUE_APP_API_URL}${pathController}/generate`, model);
        dispatch('notifications_create', {text: window.vueApp.$t('notifications.generateBlock'), title: window.vueApp.$t('left_menu.spot_programming.generate_block')});
        return request.data;
      } catch (error) {
        dispatch('notifications_create', {text: `${window.vueApp.$t('notifications.general')} ${error.message}`, title: window.vueApp.$t('left_menu.spot_programming.generate_block'), error: true});
        throw new Error(error);
      }
    },
    async trafficLog_getGenerationResults({ dispatch }, id) {
      try {
        const request = await interceptor.authenticate.get(`${process.env.VUE_APP_API_URL}${pathController}/getGenerationResults?requestId=${id}`);
        return request.data;
      } catch (error) {
        dispatch('notifications_create', {text: `${window.vueApp.$t('notifications.general')} ${error.message}`, title: window.vueApp.$t('left_menu.spot_programming.generate_block'), error: true});
        throw new Error(error);
      }
    },
    async trafficLog_getGenerationReport({ dispatch }, model) {
      try {
        const request = await interceptor.authenticate.post(`${process.env.VUE_APP_API_URL}${pathController}/getGenerationReport`, model);
        return request.data;
      } catch (error) {
        dispatch('notifications_create', {text: `${window.vueApp.$t('notifications.general')} ${error.message}`, title: window.vueApp.$t('left_menu.report.generation_report'), error: true});
        throw new Error(error);
      }
    }
  }
}

